import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { useRouter } from "next/router";

interface AuthContextType {
    redirectTo: string | null;
    setRedirectTo: (path: string | null) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const router = useRouter();
    const [redirectTo, setRedirectTo] = useState<string | null>(null);

    useEffect(() => {
        // Only set redirectTo if it's null and the user is NOT on login/register or landing pages
        if (
            !router.pathname.includes("/app/login") &&
            !router.pathname.includes("/app/register") &&
            !router.pathname.includes("/app/forgot-password") &&
            !router.pathname.includes("/app/change-password") &&
            router.pathname !== "/"

        ) {
            // console.log("Captured Redirect URL:", router.asPath);
            setRedirectTo(router.asPath);
        }
    }, [router.asPath]);

    return (
        <AuthContext.Provider value={{ redirectTo, setRedirectTo }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
